import { PATH_APP } from "../paths";
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import AuthProtect from "src/components/Auth/AuthProtect";
import Roles from "src/utils/Roles";

// ----------------------------------------------------------------------

const TpvRoutes = {
  path: PATH_APP.tuCarta.root,
  guard: AuthProtect,
  routes: [
    // tucarta
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tuCarta.cartaCamarero,
      component: lazy(() =>
        import(
          "src/views/app/UserNormal/cartaCamarero/tuCartaCamarero/DarkKitchen"
        )
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tuCarta.root,
      component: () => <Redirect to={PATH_APP.tuCarta.tpv} />,
    },
    {
      component: () => <Redirect to="/404" />,
    },
  ],
};

export default TpvRoutes;
